@if (exam != undefined) {
  <div class="text-center">
    @if (exam.status === 'ready_to_start' || exam.status === 'not_started') {
      <div [class]="readyStyle">
        Open
      </div>
    }
    @if (exam.status === 'in_progress') {
      <div [class]="inProgressStyle">
        {{ statusFormatterPipe.transform(exam.status) }}
      </div>
    }
    @if (exam.status === 'completed' || exam.status === 'submitted' || exam.status === 'scored') {
      <div [class]="completedStyle">
        {{ statusFormatterPipe.transform(exam.status) }}
      </div>
    }
    @if (exam.status === 'out_of_time' || exam.status === 'too_late_to_start' || exam.status === 'overtime' || exam.status === 'past_due') {
      <div [class]="outOfTimeStyle">
        {{ statusFormatterPipe.transform(exam.status) }}
      </div>
    }
  </div>
}
